import { cajaDetalle } from './cajaDetalle';
import { Clientes } from './cliente';
import { Compradetalle } from './compradetalle';


export class Caja {
    id:number;
    idEmisor:number;
    fecha:string;
    total:number;
    efectivo:number;
    tarjeta:number;
    transferencia:number;
    credito:number;
    caja:number;
    estado:string;
    usuario:string;
    detalle:cajaDetalle;
    gastos:number;
    totalCaja:number;
    

    }
    